const getBase64 = (file, cb) => {
  let reader = new window.FileReader()
  reader.readAsDataURL(file)
  reader.onload = function () {
    cb(reader.result)
  }
  reader.onerror = function (error) {
    console.log('Error: ', error)
  }
}

export default getBase64


// WEBPACK FOOTER //
// ./src/utils/base64.js